import { parsePhoneNumber } from "awesome-phonenumber";

function createFormatter() {
  function isValidNumber(number: string) {
    const phoneNumber = parsePhoneNumber(number, { regionCode: "US" });
    return phoneNumber.valid;
  }
  function isE164(number: string) {
    return /^\+?[1-9]\d{10,14}$/.test(number);
  }
  function formatE164(number: string) {
    const phoneNumber = parsePhoneNumber(number, { regionCode: "US" });
    return phoneNumber.number?.e164 ?? number;
  }
  function formatNational(number: string) {
    const phoneNumber = parsePhoneNumber(number, { regionCode: "US" });
    return phoneNumber.number?.national ?? number;
  }

  function formatNationalIfValid(number: string) {
    const phoneNumber = parsePhoneNumber(number, { regionCode: "US" });
    return phoneNumber.valid ? phoneNumber.number.national : number;
  }

  function formatNumberWithoutCountryPrefix(number: string) {
    const phoneNumber = parsePhoneNumber(number, { regionCode: "US" });
    return phoneNumber.number?.significant ?? number;
  }

  return {
    isValidNumber,
    isE164,
    formatE164,
    formatNational,
    formatNationalIfValid,
    formatNumberWithoutCountryPrefix,
  };
}

export const phoneFormatter = createFormatter();
